module.exports = __webpack_public_path__ + "img/diafan.a3dd6244.png";